import React, { Component } from 'react'
import { Service } from '../ApiService';
import Table from '../Table'
import { Helper } from '../Helper'
import { withStore } from '../store';
import { Elements, StripeProvider } from 'react-stripe-elements/dist/react-stripe-elements';
import CheckoutForm from './CheckoutForm'
import CheckoutForm3DAuthorization from './CheckoutForm3DAuthorization'
import './Checkout.css'
import Alert from '../Alert'
//import { loadStripe } from "@stripe/stripe-js";

class Checkout extends Component {

    constructor(props) {
        super(props);
        props.store.refreshUserInfo();

        this.state = {
            order: {
                user: null,
                orderId: props.match.params.id,
                orderServiceLines: [],
                amount: 0,
                discount: 0,
                fee: 0,
                taxAmount: 0,
                totalAmount: 0,
                card: '',
                createdDate: '',
                orderNumber: 0,
                paidDate: '',
                transactionId: '',
                status: ''
            },
            userInfo: {},
            loading: false,
            paying: false
        }

        this.use3DAuthorization = false;
    }


    updateEventOrderProperties = (data) => {
        var order = { ...this.state.order };
        order.orderServiceLines = data.orderServiceLines;
        order.taxAmount = data.taxAmount;
        order.totalAmount = data.totalAmount;
        order.amount = data.amount;
        order.discount = data.discount;
        order.fee = data.fee;
        order.card = data.card;
        order.createdDate = data.createdDate;
        order.orderNumber = data.orderNumber;
        order.paidDate = data.paidDate;
        order.transactionId = data.transactionId;
        order.orderId = data.orderId;
        order.isDiscountedPeriod = data.isDiscountedPeriod;
        order.user = data.user;
        order.status = data.status;
        this.setState({
            order: order,
            loading: false,
            addingService: false,
        })
    }

    componentDidMount = () => {
        Service.getMemberEventOrderById(this.state.order.orderId)
            .then(data => {
                this.updateEventOrderProperties(data);
            });
    }

    renderServiceName = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <span style={{ "flex": "1 1 auto", minWidth: "300px" }} className="small-bold">{row.serviceName}</span>
            </li>
        );
    }

    renderPrice = (value, row, index, col) => {
        var someDiv = '';
        if (row.price != row.overridenPrice && !this.state.order.transactionId) {
            someDiv = <div className='input-button-wrapper checkout-price-column'>
                <span style={{ 'text-decoration': 'line-through' }}>{Helper.CurrencyFormat(row.price)}</span>
                <span>{Helper.CurrencyFormat(row.overridenPrice)}</span>
            </div>;
        }
        else {
            someDiv = <div className='input-button-wrapper checkout-price-column'>
                <span>{Helper.CurrencyFormat(row.overridenPrice)}</span>
            </div>;
        }
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                {!row.isPriceOverriden ?
                    someDiv
                    :
                    <div className='input-button-wrapper checkout-price-column'>
                        <span>Special Price</span>
                        <span>{Helper.CurrencyFormat(row.overridenPrice)}</span>
                    </div>
                }
            </li>
        )
    }
    
    renderTax = (value, row, index, col) => {
        var price = row.overridenPrice == 0 ? row.price : row.overridenPrice;
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <div className='input-button-wrapper checkout-price-column'>
                    <span>Sales Tax 6%</span>
                    <span>{Helper.CurrencyFormat(price * 0.06)}</span>
                </div>
            </li>
        )
    }

    renderTotalName = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <span style={{ "flex": "1 1 auto", minWidth: "300px" }} className="big-bold">{value}</span>
            </li>
        );
    }

    renderTotalPrice = (value, row, index, col) => {
        return (
            <li key={index} className={col.className ? "table-content " + col.className : "table-content"}>
                <div className='input-button-wrapper checkout-price-column'>
                    <span>{Helper.CurrencyFormat(value, true)}</span>
                </div>
            </li>
        )
    }

    proceedWithPayment = async () => {
        if (this.use3DAuthorization) {
            let response = await fetch("/api/Pay/GetPaymentIntent", {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                method: "POST",
                //headers: { "Content-Type": "text/plain" },
                body: JSON.stringify({
                    amount: this.state.order.totalAmount + this.state.order.fee,
                    fee: this.state.order.fee
                })
            });

            response.json().then((data) => {
                this.setState({ paying: true, paymentIntent: data })
            });
        }
        else {
            this.setState({ paying: true })
        }

    }

    refundPayment = () => {
        Service.RefundPayment(this.state.order.orderId).then(res => {
            if (res.success) {
                var order = { ...this.state.order };
                order.status = 'Refunded';
                this.setState({
                    order: order,
                    loading: false,
                    showMessage: false,
                })
            }
            else {
                this.setState({
                    showMessage: false,
                })
            }
        })
    }


    render = () => {
        const orderServiceLines = this.state.order.orderServiceLines;

        const columns = [
            { title: "", accesor: "name", className: "borders-when-display-block", render: this.renderServiceName },
            { title: "", accesor: "oneTimePrice", render: this.renderPrice },
            //{ title: "", accesor: "oneTimePrice", render: this.renderTax },
        ];

        const totalAmountColumns = [
            { title: "", accesor: "text", className: "borders-when-display-block", render: this.renderTotalName },
            { title: "", accesor: "amount", render: this.renderTotalPrice },
            //{ title: "", accesor: "tax", render: this.renderTotalPrice },
        ];

        var totalAmountData = [
            { text: 'Discount', amount: this.state.order.discount/*, tax: null*/ },
            { text: 'Subtotal', amount: this.state.order.amount - this.state.order.discount/*, tax: this.state.order.taxAmount*/ },
            { text: 'Tax', amount: this.state.order.taxAmount },
            { text: 'Total', amount: this.state.order.totalAmount/*, tax: this.state.order.totalAmount*/ },
            { text: 'Fee', amount: this.state.order.fee/*, tax: this.state.order.fee*/ },
            { text: 'Total + Fee', amount: this.state.order.totalAmount + this.state.order.fee},
        ]

        //pk_test_xMs3Jv9wFZpbOCgOih2TK2nW00bxku1Y8Q
        //pk_live_Mb85RCfia3zf7WexIo7FB3CF005jyEszWi

        var ctrl = '';

        if (!this.state.order.user) {
            return <div>No User Data</div>
        }

        if (this.state.paying) {
            ctrl = <StripeProvider apiKey="pk_live_Mb85RCfia3zf7WexIo7FB3CF005jyEszWi"> 
                <div className="shopping-cart pages-wsm-wrapper ipw-1000 prpl-0">
                    <Elements>
                        {!this.use3DAuthorization && <CheckoutForm orderId={this.state.order.orderId} paymentIntent={this.state.paymentIntent} />}
                        {/*this.use3DAuthorization && <CheckoutForm3DAuthorization orderId={this.state.order.orderId} paymentIntent={this.state.paymentIntent} />*/}
                    </Elements>
                </div>
            </StripeProvider>
        }
        else {
            ctrl = <div className='shopping-cart pages-wsm-wrapper ipw-1000 prpl-0'>
                <div className='cart-title'>
                    <span>Order Details</span>
                    {this.state.order.status != 'Draft' && <span className={this.state.order.status}>{this.state.order.status}</span>}
                    <span>Order# {this.state.order.orderNumber}</span>
                </div>
                <div style={{ display: 'contents' }}>
                    <span className="small-bold">{this.state.order.user.companyName}</span>
                    <span className="small-bold">{this.state.order.user.address} {this.state.order.user.city} {this.state.order.user.state} {this.state.order.user.zip}</span>
                </div>
                <div className='mt-2'>
                    <p>You have chosen to add the following services</p>
                    <Table columns={columns} data={orderServiceLines}
                        className={"break-at-500 checkout-table"}
                        addHeadersForNarrowScreen={true} />
                </div>

                <div>
                    <Table columns={totalAmountColumns} data={totalAmountData}
                        className={"checkout-total-table"} />
                    {/*addHeadersForNarrowScreen={true} />*/}
                </div>


                {/*    <span style={{ "display": "flex", "flexFlow": "column", "flexWrap": "nowrap", "flex": "1 1 auto" }} className="blue-link">
                        <span style={{ "fontSize": "1.1em", "flex": "1 1 auto" }} onClick={e =>
                            Service.GetPaymentInfo(this.state.order.orderId).then(res => {
                                if (res.success) {
                                    window.open(res.data.receiptUrl, "_blank");
                                }
                                else {
                                    this.headerText = 'Failure';
                                    this.dialogText = "Unable to get payment";
                                    this.dialogContent = <h4>{res.message}</h4>
                                    this.mode = 'error'
                                    this.setState({ showMessage: true });
                                    return Promise.reject(new Error(res.message));
                                }
                            })
                                .catch(err => {
                                    console.log(err);
                                })
                        }>View payment details</span>
                    </span>
                    :*/}
                <div className='flex-wrap mt-2'>
                    <button
                        className='medium-static-button static-button'
                        onClick={() => this.props.history.goBack()}
                    >Back</button>

                    {this.state.order.transactionId ?
                        <button
                            className='medium-static-button static-button default-button'
                            onClick={() => Service.GetPaymentInfo(this.state.order.orderId).then(res => {
                                if (res.success) {
                                    window.open(res.data.receiptUrl, "_blank");
                                }
                                else {
                                    this.headerText = 'Failure';
                                    this.dialogText = "Unable to get payment";
                                    this.dialogContent = <h4>{res.message}</h4>
                                    this.mode = 'error'
                                    this.setState({ showMessage: true });
                                    return Promise.reject(new Error(res.message));
                                }
                            })
                                .catch(err => {
                                    console.log(err);
                                })}>View payment check</button>
                        :
                        this.state.order.user.noTaxCertificateOrValid ?
                            <button
                                className='medium-static-button static-button default-button'
                                onClick={() => this.proceedWithPayment()}>Pay</button>
                            :
                            <strong style={{ 'color': 'red' }}>Tax Exempt Certificate Not Valid</strong>

                    }

                    {this.state.order.status == 'Paid' && this.props.store.userInfo && this.props.store.userInfo.authType == "Admin" ?
                        <button
                            className='medium-static-button static-button default-button refundButton'
                            onClick={() => this.setState({ showMessage: true })}>Refund</button>
                        : ''
                    }

                </div>

                {this.state.showMessage && <Alert
                    headerText='Refund'
                    text='This action cannot be undone. Refund anyway?'
                    onClose={() => this.setState({ showMessage: false })}
                    showOkCancelButtons={true}
                    onCancelButtonClick={() => this.setState({ showMessage: false })}
                    onOkButtonClick={() => { this.refundPayment() }}
                    cancelButtonText="No"
                    okButtonText="Yes"
                    mode='question'
                >
                    <h4 className='mb-05'>Are you sure want to mark as refunded order#{this.state.order.orderNumber} with amount {Helper.CurrencyFormat(this.state.order.totalAmount, true) } for {this.state.order.user.companyName}?</h4>
                </Alert>}

            </div>
        }
        return (
            ctrl
        )
    }
}

export default withStore(Checkout);


// WEBPACK FOOTER //
// ./src/components/Payment/Checkout.jsx